export default __webpack_public_path__ + "static/media/setting_icon_normal.acc6f023.svg";